import { useEffect, useState } from "react";
import { secondsToTimeString } from "@circle-react/helpers/dateTimeHelpers/index";

interface TimerProps {
  isRecording: boolean;
}

export const Timer = ({ isRecording }: TimerProps) => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (isRecording) {
      const timer = setInterval(() => {
        setSeconds(prevSeconds => prevSeconds + 1);
      }, 1000);
      return () => clearInterval(timer);
    }
    return () => {};
  }, [isRecording]);

  return <div>{secondsToTimeString(seconds)}</div>;
};
